import * as React from 'react';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {FormField} from '../form/form-field';
import type {SavedSettingToastState} from '../saved-setting-toast/saved-setting-toast';
// @ts-expect-error
import {TextField, TextFieldProps} from '../textfield/textfield';

type OwnProps = {
    title?: string;
    subtitle?: string;
    placeholder?: string;
    helperText?: string;
    multiline?: boolean;
    isRequired?: boolean;
    focusOnMount?: boolean;
    noMargin?: boolean;
    tooltipInfo?: string;
    saveToastState?: SavedSettingToastState;
    errorMessage?: string;
} & TextFieldProps;

type Props = FieldProps & OwnProps;

export function ReduxFormTextField({
    title,
    subtitle,
    helperText,
    isRequired,
    noMargin,
    input,
    meta,
    tooltipInfo,
    saveToastState,
    errorMessage,
    ...restProps
}: Props) {
    return (
        <FormField
            innerId={input.name}
            label={title}
            sublabel={subtitle}
            helperText={helperText}
            errorMessage={errorMessage || (meta.error && meta.submitFailed ? meta.error : null)}
            isRequired={isRequired}
            noMargin={noMargin}
            tooltipInfo={tooltipInfo}
            saveToastState={saveToastState}
        >
            <TextField {...input} {...restProps} />
        </FormField>
    );
}
